import React, {  useState, useEffect } from 'react';
import Select from 'react-select';
import { useGlobalState } from '../contexts/GlobalContext';
import { apiFetch } from '../utils/api';
import Snackbar from './Snackbar';



function AddTaskForm({ onAddTask, contactId, defaultTaskType }) {
  const { state } = useGlobalState();
  const contacts = state.contacts;

  const [taskType, setTaskType] = useState(defaultTaskType || 'call');
  const [taskDescription, setTaskDescription] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [urgency, setUrgency] = useState('medium');
  const [selectedContact, setSelectedContact] = useState(null);
  const [snackbar, setSnackbar] = useState({ show: false, message: '', type: 'success' });

  
  const contactOptions = (contacts || []).map((contact) => ({
    value: contact.id,
    label: `${contact.name} - ${contact.email}`,
  }));
  

  // ✅ Only re-run when `contactId` changes
  useEffect(() => {
    if (contactId) {
      const preselectedContact = contactOptions.find((option) => option.value === contactId);
      setSelectedContact(preselectedContact || null);
    }
  }, [contactId]);  // ✅ Removed `contactOptions` from dependencies

  const handleSubmit = async (e) => {
    e.preventDefault();
      const payload = {
        contact_id: contactId || (selectedContact ? selectedContact.value : null),
        task_type: taskType,
        task_description: taskDescription,
        due_date: dueDate,
        urgency: 'medium',
        creator_id: state.user.id,
      };

    try {
      const result = await apiFetch('createTask', {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      

      if (!result.success) {
        setSnackbar({ show: true, message: `❌ ${result.message}`, type: 'danger' });
        return;
      }

      onAddTask &&
        onAddTask({
          taskId: result.taskId,
          status: 'open',
          taskType,
          taskDescription,
          dueDate,
          urgency,
          contactId: payload.contact_id,
        });
        

      setTaskType(defaultTaskType || 'call');
      setTaskDescription('');
      setDueDate('');
      setUrgency('medium');
      setSelectedContact(null);

    } catch (err) {
      console.error('Error creating task:', err);
      setSnackbar({ show: true, message: `❌ ${err.message}`, type: 'danger' });
    }
  };

  return (
    <>
    <Snackbar
      show={snackbar.show}
      message={snackbar.message}
      type={snackbar.type}
      onClose={() => setSnackbar((s) => ({ ...s, show: false }))}
    />
    <form onSubmit={handleSubmit} className="container bg-light shadow-sm rounded p-2">
      <h6 className="text-center mb-2">Create Task</h6>

      <div className="row g-1">
        {/* Task Type */}
        <div className="col-md-4">
          <select
            className="form-select form-select-sm"
            value={taskType}
            onChange={(e) => setTaskType(e.target.value)}
            required
          >
            <option value="Call">Call</option>
            <option value="Text">Text</option>
            <option value="Email">Email</option>
            <option value="Appointment">Appointment</option>
            <option value="Closing">Closing</option>
            <option value="Inspection">Inspection</option>
            <option value="Due Diligence">Due Diligence Over</option>
          </select>
        </div>

        {/* Due Date */}
        <div className="col-md-4">
          <input
            type="date"
            className="form-control form-control-sm"
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
            required
          />
        </div>
         {/* Contact Selector */}
        {!contactId && (
          <div className="col-md-4">
            <Select
              options={contactOptions}
              value={selectedContact}
              onChange={setSelectedContact}
              placeholder="Select contact..."
              isSearchable
              classNamePrefix="react-select"
              styles={{
                control: (base) => ({ ...base, height: '30px', minHeight: '30px' }),
              }}
            />
          </div>
        )}
        

       

        {/* Task Description */}
        <div className="col-12">
          <textarea
            className="form-control form-control-sm"
            style={{ height: '50px', resize: 'none' }}
            placeholder="Task Description"
            value={taskDescription}
            onChange={(e) => setTaskDescription(e.target.value)}
            required
          />
        </div>
      </div>

      {/* Submit Button */}
      <div className="text-center mt-2">
        <button type="submit" className="btn btn-primary btn-sm px-3 py-1">Add</button>
      </div>
    </form>
    </>
  );
}

export default AddTaskForm;
